import { IIdName } from '@/interfaces/general/IIdName.ts';
import { ICountry } from '@/interfaces/general/ICountry.ts';
import { IBingoPlantStatus } from '@/interfaces/powerMarkets/bingo/IBingoPlantStatus.ts';
import { ICategoriesByCountry, ISeries, ISeriesData } from './ISeriesData.ts';
import { IDashboardPreset } from './dashboard/IDashboardPreset.ts';
import { ILiveTableOptions } from './table/ILiveTableOptions.ts';
import { IFuelType } from './IFuelType.ts';

export interface IMapCountry {
    id: string;
    name: string;
    mapId: string;
    shortName: string;
    countryEnum: number;
    nameNoBrackets: string;
}

interface ILiveTableSearch {
    categoriesByCountry: ICategoriesByCountry;
    series: Record<string, ISeries>;
}

export interface IStaticStore {
    fuelTypes: Array<IFuelType>;
    dashboardPresets: Array<IDashboardPreset>;
    countries: Array<ICountry>;
    mapCountries: Array<IMapCountry>;
    dynamicSeriesNew: ISeriesData;
    colours: Array<Array<string>>;
    iconList: Array<string>;
    plantSeries: ISeriesData;
    bingoEnums: Record<string, IBingoPlantStatus>;
    currencies: Record<string, { prefix: string; suffix: string }>;
    jointSeriesEndpoints: Array<string>;
    apiEndpointBaseUrlOverrides?: Record<string, string>;
    endpointToEarliestBufferDate: Record<string, Record<'earliestDayInBuffer', Date | null>>;
    liveTableOptions: Record<string, ILiveTableOptions>;
    bingoNamesToEnums: Record<string, string>;
    dynamicPresets: ISeriesData;
    plantPresets: ISeriesData;
    liveTableSearch: ILiveTableSearch;
    historyOfForecastsSerialised: Array<string>;
}

function createEmptySeriesData (): ISeriesData {
    return {
        categoriesByCountry: {},
        series: {},
        sourceFiltersByCountry: {},
    };
}

export function createEmptyStaticStore (): IStaticStore {
    return {
        fuelTypes: [],
        dashboardPresets: [],
        countries: [],
        mapCountries: [],
        dynamicSeriesNew: createEmptySeriesData(),
        colours: [],
        iconList: [],
        plantSeries: createEmptySeriesData(),
        bingoEnums: {},
        currencies: {},
        jointSeriesEndpoints: [],
        apiEndpointBaseUrlOverrides: {},
        endpointToEarliestBufferDate: {},
        liveTableOptions: {},
        bingoNamesToEnums: {},
        dynamicPresets: createEmptySeriesData(),
        plantPresets: createEmptySeriesData(),
        liveTableSearch: {
            categoriesByCountry: {},
            series: {},
        },
        historyOfForecastsSerialised: [],
    };
}

export interface ITimeZones {
    timeZoneInfo: Array<IIdName>;
    defaultTimeZone: IIdName;
}
